import { useRouter } from 'next/router';
import JPBundle from './JPBundle';
import NABundle from './NABundle';

export default function TabBundles() {
    const { locale = 'us' } = useRouter();
    const IS_JP_SITE = locale === 'jp';
    const IS_NA_SITES = ['us', 'ca'].includes(locale);
    const IS_EU_SITES = ['eu', 'de', 'fr', 'it', 'es'].includes(locale);
    const IS_AU_SITE = locale === 'au';

    return (
        <>
            {IS_JP_SITE && <JPBundle />}
            {(IS_NA_SITES || IS_EU_SITES || IS_AU_SITE) && <NABundle />}
        </>
    );
}
